export const associativeStepMap = new Map<string, string>([
  ['confirmOfferStep', 'common/confirm-offer/confirm-offer-step'],
  ['enterpriseIdentityStep', 'common/enterprise-section/enterprise-identity-step'],
  ['identityStep', 'common/identity-section/identity-step'],
  ['howToJoinStep', 'common/how-to-join-section/how-to-join-step'],
  ['bankAccountInfoStep', 'common/bank-account-info-section/bank-account-info-step'],
  ['summaryStep', 'common/summary-step/summary-step'],
  ['subscriptionSummaryStep', 'common/subscription-summary-step/subscriptionSummaryStep'],
  ['signatureStep', 'common/signature/signature'],
  ['confirmationStep', 'common/confirmation-step/confirmation-step'],
  ['confirmationBarcodeStep', 'common/confirmation-barcode-step/confirmation-barcode-step'],
  ['cancellationStep', 'common/cancellation-step/cancellation-step'],
  ['productStep', 'common/product-step/product-step'],
  ['tooLateStep', 'common/tooLate-step/tooLate-step'],
  ['tooEarlyStep', 'common/tooEarly-step/tooEarly-step'],
  ['customerInformationStep', 'common/customer-informations-step/customer-information-step'],
  ['newCustomerInformationStep', 'common/new-customer-information/new-customer-information-step'],
  ['endStep', 'common/end-step/end-step']
]);

export const associativeGtmStepNameMap = new Map<string, string>([
  ['confirmOfferStep', 'Landing Page'],
  ['enterpriseIdentityStep', 'Informations professionnelles'],
  ['newCustomerInformationStep', 'Informations personnelles'],
  ['identityStep', 'Informations personnelles'],
  ['howToJoinStep', 'Adresse postale'],
  ['bankAccountInfoStep', 'Coordonnées bancaires'],
  ['summaryStep', 'Récapitulatif'],
  ['subscriptionSummaryStep', 'Récapitulatif'],
  ['signatureStep', 'Init Signature'],
  ['confirmationStep', 'Confirmation adhésion'],
  ['confirmationBarcodeStep', 'Confirmation adhésion - Code à barre'],
  ['cancellationStep', 'Annulation adhésion'],
  ['productStep', 'Product Page'],
  ['tooLateStep', 'Trop tard'],
  ['tooEarlyStep', 'Trop tôt']
]);
